import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

/*
badges are small tags used to add context
badges scale to match the size of the immediate parent element
style modifier classes include: primary, secondary, success, danger, warning, info, light and dark

Component Call:
<DynamicBadge
  bg=("Primary","Secondary", etc) - background color
  pill - if declared, sets the badge-pill class to round the edges of the badge
>
{values to display}
</DynamicBadge>
*/

const DynamicBadge = props => {
  const {
    children,
    bg,
    bw,
    pill,
    tooltipText = null,
    placeRight = false,
    marginRight = false,
  } = props;

  const pillClass = pill ? 'badge-pill' : '';
  const positioningClass = placeRight ? 'float-right' : '';
  const marginClass = marginRight ? 'mr-2' : 'ml-2';
  const badgeColor = !isEmpty(bg) ? bg.toLowerCase() : '';
  const badgeWidth = !isEmpty(bw) ? bw.toLowerCase() : 'width-1';

  return (
    <span
      className={`badge badge-${badgeColor} ${badgeWidth} ${pillClass} ${positioningClass} ${marginClass}`}
      data-toggle={tooltipText ? 'tooltip' : null}
      title={tooltipText}
    >
      {children}
    </span>
  );
};

DynamicBadge.propTypes = {
  children: PropTypes.node.isRequired,
  bg: PropTypes.string.isRequired,
  bw: PropTypes.string,
  pill: PropTypes.bool,
  tooltipText: PropTypes.string,
  placeRight: PropTypes.bool,
  marginRight: PropTypes.bool,
};

DynamicBadge.defaultProps = {
  pill: PropTypes.null,
};

export default DynamicBadge;
